import React from "react";
import styles from "./admin.module.scss";
import Icon, { IconName } from "./Icon";

interface EmptyStateProps {
  title: React.ReactNode;
  children?: React.ReactNode;
  icon?: IconName;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  children,
  icon = "inbox",
  action,
}) => (
  <div className={styles.empty}>
    <span className={styles.emptyIcon}>
      <Icon name={icon} size={22} />
    </span>
    <span className={styles.emptyTitle}>{title}</span>
    {children && <span>{children}</span>}
    {action}
  </div>
);

export default EmptyState;
